(function() {
  "use strict";

  class ProductModelClass extends window.theme.DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent();
      Shopify.loadFeatures([{
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }]);
    }
    setupModelViewerUI(t) {
      if (!t) {
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer"));
      }
    }
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([{
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this)
      }]);
    },
    setupShopifyXR(t) {
      if (!t) {
        if (window.ShopifyXR) {
          document.querySelectorAll('[id^="ModelJSON-"]').forEach((t => {
            window.ShopifyXR.addModels(JSON.parse(t.textContent));
            t.remove();
          }));
          window.ShopifyXR.setupXRElements();
        } else {
          document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR()));
        }
      }
    }
  };

  window.addEventListener("DOMContentLoaded", (() => {
    if (window.ProductModel) {
      window.ProductModel.loadShopifyXR();
    }
  }));

  const SELECTOR_ADD_TO_CART = "[data-add-to-cart]";
  const SELECTOR_PRODUCT_JSON = "[data-product-json]";
  const SELECTOR_PRODUCT_FORM = "[data-product-form]";
  const SELECTOR_CART_BAR = "#cart-bar";
  const SELECTOR_POPUP_OPEN = "[data-popup-open]";
  const SELECTOR_SUBMIT_ADD = ".product__submit__add";
  const SELECTOR_FORM_WRAPPER = "[data-form-wrapper]";
  const SELECTOR_PRODUCT_VARIANTS = "[data-product-variants]";
  
  const CLASS_LOADING = "is-loading";
  const CLASS_VISIBLE = "is-visible";
  
  const ATTR_CART_BAR_ENABLED = "data-cart-bar-enabled";
  const ATTR_ADD_TO_CART_BAR = "data-add-to-cart-bar";
  const ATTR_CART_BAR_SCROLL = "data-cart-bar-scroll";
  const ATTR_CART_BAR_NOTIFICATION = "data-cart-bar-product-notification";
  const ATTR_STICKY_ENABLED = "data-sticky-enabled";

  if (!customElements.get("product-component")) {
    customElements.define("product-component", class extends HTMLElement {
      constructor() {
        super();
        this.stickyEnabled = this.getAttribute(ATTR_STICKY_ENABLED) === "true";
        this.formWrapper = this.querySelector(SELECTOR_FORM_WRAPPER);
        this.cartBarEnabled = this.hasAttribute(ATTR_CART_BAR_ENABLED);
        this.cartBar = this.querySelector(SELECTOR_CART_BAR);
        this.setCartBarHeight = this.setCartBarHeight.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
        this.unlockTimer = 0;
      }

      connectedCallback() {
        const productJsonEl = this.querySelector(SELECTOR_PRODUCT_JSON);
        if (!productJsonEl || !productJsonEl.innerHTML) return;

        const handle = JSON.parse(productJsonEl.innerHTML).handle;
        let recentViewedData = {};
        if (handle) {
          recentViewedData = { handle: handle };
        }
        
        if (Shopify.Products && Shopify.Products.recordRecentlyViewed) {
          Shopify.Products.recordRecentlyViewed(recentViewedData);
        }

        this.form = this.querySelector(SELECTOR_PRODUCT_FORM);
        if (this.cartBarEnabled) {
          this.initCartBar();
          this.setCartBarHeight();
          document.addEventListener("theme:scroll", this.toggleCartBarOnScroll);
          document.addEventListener("theme:resize", this.setCartBarHeight);
          this.initCartBarObserver();
        }
      }

      initCartBar() {
        this.cartBarBtns = this.cartBar.querySelectorAll(SELECTOR_SUBMIT_ADD);
        if (this.cartBarBtns.length > 0) {
          this.cartBarBtns.forEach((btn => {
            btn.addEventListener("click", (e => {
              e.preventDefault();
              const currentTarget = e.currentTarget;
              if (currentTarget.hasAttribute(ATTR_ADD_TO_CART_BAR)) {
                if (this.cartBarEnabled) {
                  currentTarget.classList.add(CLASS_LOADING);
                  currentTarget.setAttribute("disabled", "disabled");
                }
                this.form.querySelector(SELECTOR_ADD_TO_CART).dispatchEvent(new Event("click", { bubbles: true }));
              } else if (currentTarget.hasAttribute(ATTR_CART_BAR_SCROLL)) {
                this.scrollToTop();
              } else if (currentTarget.hasAttribute(ATTR_CART_BAR_NOTIFICATION)) {
                this.form.querySelector(SELECTOR_POPUP_OPEN)?.dispatchEvent(new Event("click"));
              }
            }));
            if (btn.hasAttribute(ATTR_ADD_TO_CART_BAR)) {
              document.addEventListener("theme:product:add-error", this.scrollToTop);
            }
          }));
        }
        this.setCartBarHeight();
      }

      initCartBarObserver() {
        const supportingMenu = document.querySelector(".supporting-menu");
        if (supportingMenu && this.cartBar) {
          this.cartBarObserver = new IntersectionObserver((entries => {
            entries.forEach((entry => {
              if (entry.isIntersecting) {
                this.cartBar.style.transform = "translateY(150%)";
                this.cartBar.style.transition = "transform 0.3s ease";
                document.documentElement.style.setProperty("--cart-bar-height", "0px");
              } else {
                this.cartBar.style.transform = "";
                this.setCartBarHeight();
              }
            }));
          }), {
            root: null,
            rootMargin: "0px",
            threshold: 0.01
          });
          this.cartBarObserver.observe(supportingMenu);
        }
      }

      scrollToTop() {
        const variantsEl = this.querySelector(SELECTOR_PRODUCT_VARIANTS);
        const topPos = (window.theme.isMobile() ? (variantsEl || this.form) : this).getBoundingClientRect().top;
        window.theme.scrollTo(window.theme.isMobile() ? topPos - 10 : topPos);
      }

      toggleCartBarOnScroll() {
        const scrollY = window.scrollY;
        const targetEl = window.theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
        if (targetEl && this.cartBar) {
          const isVisible = scrollY > targetEl.offsetTop + targetEl.offsetHeight;
          this.cartBar.classList.toggle(CLASS_VISIBLE, isVisible);
        }
      }

      setCartBarHeight() {
        const height = this.cartBar.offsetHeight;
        document.documentElement.style.setProperty("--cart-bar-height", `${height}px`);
      }

      disconnectedCallback() {
        document.removeEventListener("theme:product:add-error", this.scrollToTop);
        if (this.cartBarEnabled) {
          document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll);
          document.removeEventListener("theme:resize", this.setCartBarHeight);
          if (this.cartBarObserver) {
            this.cartBarObserver.disconnect();
          }
        }
      }
    });
  }

  if (!customElements.get("product-model")) {
    customElements.define("product-model", ProductModelClass);
  }
})();
